import { MagicItemCategory } from './MagicItemCategory';

export interface UnitOptionMagicItemCategory extends MagicItemCategory {
  ratio: number;
  ratioAction: RatioAction;
  minByModel: number;
  maxByModel: number | null;
}

export enum RatioAction {
  Multiplier = 'multiplier',
  Decreasing = 'decreasing',
}
